// assets/cart-count.js

// カウントを全ての .cart-count 要素に反映
const setCount = (n) => {
  document.querySelectorAll('.cart-count').forEach((el) => {
    el.textContent = n;
    el.hidden = (n === 0);
  });
};

// カートの中身を取得して更新
const refreshCount = () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(c => setCount(c.item_count))
    .catch(() => {});
};

document.addEventListener('DOMContentLoaded', refreshCount);

// よくあるイベントで更新（テーマごとに拾えるイベントが違うので多めに）
['cart:refresh', 'cart:updated', 'product:added', 'change'].forEach(evt => {
  document.addEventListener(evt, refreshCount, true);
});

// Ajax非対応テーマ用フォールバック（フォーム送信を拾う）
document.addEventListener('submit', (e) => {
  const f = e.target;
  if (f.matches('form[action*="/cart/add"], product-form, form[action="/cart"]')) {
    setTimeout(refreshCount, 700); // 追加/更新後に再取得
  }
});